import { Paged } from 'api/common/types/Page';
import Http from '../../common/services/Http';
import { VehicleReservationDto } from './models/VehicleReservationDto';
import { VehicleReservationHistoryDto } from './models/VehicleReservationHistoryDto';
import { VehicleReservationVerificationsSearchCriteria } from './models/VehicleReservationVerificationsSearchCriteria';
import { VehicleReservationVerificationViewModel } from './models/VehicleReservationVerificationViewModel';
import { ReservationTripItemViewModel } from './models/ReservationTripItemViewModel';
import { VehicleReservationsSearchCriteria } from './models/VehicleReservationsSearchCriteria'
import { ReservationsVehicleListItemDto }  from '../vehicles/models/ReservationsVehicleListItemDto'


class VehicleReservationsService {

    public getById(id: string) {
        return Http.get<VehicleReservationDto>('vehicleReservations/' + id);
    }


    public getVehicles(criteria: VehicleReservationsSearchCriteria) {
        return Http.get<Paged<ReservationsVehicleListItemDto>>('vehicleReservations/getVehicles', criteria);
    }

    public getListByVehicleId(criteria: VehicleReservationsSearchCriteria) {
        return Http.get<Paged<VehicleReservationDto>>('vehicleReservations', criteria);
    }

    public validateDates(criteria: VehicleReservationsSearchCriteria) {
        return Http.get<boolean>('vehicleReservations/validateDates', criteria);
    }

    public create(model: VehicleReservationDto) {
        return Http.post<string>('vehicleReservations', model);
    }

    public update(model: VehicleReservationDto) {
        return Http.put('vehicleReservations', model);
    }

    public remove(model: VehicleReservationDto) {
        return Http.put('vehicleReservations/deactivate', model);
    }
   
    public getListReservationVerification(criteria: VehicleReservationVerificationsSearchCriteria) {
        return Http.get<Paged<VehicleReservationVerificationViewModel>>('vehicleReservations/vehicle-reservation-verification', criteria);
    }

    public getReservationTrips(criteria: VehicleReservationVerificationsSearchCriteria) {
        return Http.get<Paged<ReservationTripItemViewModel>>('vehicleReservations/reservation-trips', criteria);
    }

    public getMyRequests(criteria: VehicleReservationsSearchCriteria) {
        return Http.get<Paged<VehicleReservationDto>>('vehicleReservations/requests', criteria);
    }

    public approve(id: string, vehicleId?: string) {
        return Http.post(`vehicleReservations/${id}/approve`, { id, vehicleId });
    }

    public reject(id: string, rejectionReason: string) {
        return Http.post(`vehicleReservations/${id}/reject`, { id, rejectionReason });
    }

    public getAllRequests(criteria: VehicleReservationsSearchCriteria) {
        return Http.get<Paged<VehicleReservationDto>>('vehicleReservations/all-requests', criteria);
    }

    public cancelApproval(id: string) {
        return Http.post(`vehicleReservations/${id}/cancel-approval`, { id });
    }

    public getHistory(id: string) {
        return Http.get<VehicleReservationHistoryDto[]>(`vehicleReservations/${id}/history`);
    }

    public getApprovers() {
        return Http.get<{ id: string; realName: string; email: string }[]>('vehicleReservations/approvers');
    }

}

export default new VehicleReservationsService();